import { render, staticRenderFns } from "./groups-commodity.vue?vue&type=template&id=211adce3&scoped=true&"
import script from "./groups-commodity.vue?vue&type=script&lang=js&"
export * from "./groups-commodity.vue?vue&type=script&lang=js&"
import style0 from "./groups-commodity.vue?vue&type=style&index=0&id=211adce3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211adce3",
  null
  
)

export default component.exports